// Data del sito La Renaissance Valdôtaine

export const siteInfo = {
  name: "La Renaissance Valdôtaine",
  slogan: "Movimento civico per la rinascita di Aosta e della Valle d'Aosta",
  description: "La Renaissance Valdôtaine nasce come movimento politico dalla spinta verso un imprescindibile, irrimandabile e necessario processo di cambiamento.",
  logo: "https://customer-assets.emergentagent.com/job_civico-evolution/artifacts/0wgnpjyh_IMG_2193.jpeg",
  social: {
    instagram: "https://www.instagram.com/renaissance.vda",
    facebook: "https://www.facebook.com/larenaissancevaldotaine",
    youtube: "https://www.youtube.com/channel/UC2fej-dc1L2zWIsRUtDQftw"
  },
  joinForm: "https://docs.google.com/forms/d/e/1FAIpQLScTjfLZX3as5oODJzWJCF3KTBCUEho1GzZGVAoLp1bF4MXLPg/viewform"
};

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "Elezioni 2025", path: "/elezioni-2025", submenu: [
    { name: "Comunali Aosta", path: "/elezioni-comunali" },
    { name: "Regionali VdA", path: "/elezioni-regionali" }
  ]},
  { name: "Programma", path: "/programma-regionale" },
  { name: "Chi Siamo", path: "/chi-siamo", submenu: [
    { name: "La Storia", path: "/storia" },
    { name: "I Nostri Valori", path: "/valori" }
  ]},
  { name: "Trasparenza", path: "/elezioni-trasparenti" }
];

export const heroContent = {
  title: "La Renaissance Valdôtaine",
  subtitle: "Movimento civico per la rinascita di Aosta e della Valle d'Aosta",
  description: "Partecipiamo attivamente all'evoluzione del mondo, della società, della comunità. Crediamo che il percorso sia affrontabile solo con grande senso di responsabilità, lucidità e uno sguardo aperto e visionario.",
  backgroundImage: "https://images.pexels.com/photos/14549182/pexels-photo-14549182.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cta: {
    primary: { text: "Entra nella squadra", link: "https://docs.google.com/forms/d/e/1FAIpQLScTjfLZX3as5oODJzWJCF3KTBCUEho1GzZGVAoLp1bF4MXLPg/viewform" },
    secondary: { text: "Scopri di più", link: "/storia" }
  }
};

export const aboutPreview = {
  title: "Chi Siamo",
  quote: "Vogliamo rappresentare un nuovo modo di fare politica. Crediamo che l'approccio del passato non sia più proficuo: oggi più che mai è importante e necessario aprirsi a nuove opportunità, saperle cogliere e portarle avanti con fiducia e onestà.",
  text: "La Renaissance Valdôtaine – prima Rinascimento Valle d'Aosta – nasce come movimento civico nel 2020. Un gruppo di persone, stanche e sfiduciate dal sistema politico valdostano, decidono di unirsi per seguire un progetto volto a una rinascita della città di Aosta e della regione Valle d'Aosta."
};

export const programmaPreview = [
  {
    id: 1,
    icon: "Users",
    title: "Il cittadino al centro",
    description: "Coinvolgere attivamente ogni cittadino affinché la politica torni a essere patrimonio di tutti."
  },
  {
    id: 2,
    icon: "Heart",
    title: "La sanità è per tutti",
    description: "Sostenere una sanità pubblica di qualità e accessibile a tutti, rispettando le specificità locali."
  },
  {
    id: 3,
    icon: "GraduationCap",
    title: "Formazione e lavoro",
    description: "La formazione alla base del lavoro rappresenta le fondamenta di una società migliore."
  },
  {
    id: 4,
    icon: "Train",
    title: "Trasporti e infrastrutture",
    description: "Raddoppio binari ferroviari, seconda canna Traforo Monte Bianco, collegamenti efficienti."
  }
];

export const elezioni2025 = {
  comunali: {
    title: "Elezioni Comunali Aosta 2025",
    subtitle: "Lista LA RENAISSANCE VALDÔTAINE",
    candidatoSindaco: {
      nome: "Giovanni Girardini",
      ruolo: "Candidato Sindaco",
      cv: "https://drive.google.com/file/d/1jD_JYzMFbp4Vx4qjeoRRMfJIg4YMCnjO/view",
      certificato: "https://drive.google.com/file/d/1PO5kDDvnyzwIBwhnK0bnrl7DRuP-pNHC/view"
    },
    candidatoVice: {
      nome: "Sonia Furci",
      ruolo: "Candidato Vicesindaco",
      cv: "https://drive.google.com/file/d/1OMdy_baV5UgWQ2mzuX5_WFrtF4X3LvBQ/view",
      certificato: "https://drive.google.com/file/d/1PZc9X-LvICMLxyx2T-zZk7OxHNumYoDr/view"
    },
    programma: "https://drive.google.com/file/d/1A2RU_QfFWu-cHwc4e9tCgNp462wkPB5q/view"
  },
  regionali: {
    title: "Elezioni Regionali VdA 2025",
    subtitle: "LISTA UNICA INSIEME - ENSEMBLE",
    coalition: "RENAISSANCE VALDOTAINE - FORZA ITALIA",
    programma: "/programma-regionale"
  }
};

export const candidatiComunali = [
  { nome: "DATTOLA Cristina", cv: "https://drive.google.com/file/d/1XMgPhgf3Ukl1nkp4lMZqRNIYwFgtrYCO/view", certificato: "https://drive.google.com/file/d/10Ydep_auncwwmEMta4rzOqgdHEURp73K/view" },
  { nome: "ANELLO Barbara Stefania", cv: "https://drive.google.com/file/d/1xqisIuTiywYP4pv7W9Fk0X4StdEZ_2J0/view", certificato: "https://drive.google.com/file/d/14-kREMrepgn5iUi6bsQ2_uB3zEDLxvW3/view" },
  { nome: "BASSINO Adriana", cv: "https://drive.google.com/file/d/1TLCq11V1TZsD2IIIau7b7xzwbBDvo0y7/view", certificato: "https://drive.google.com/file/d/1iRYeoPn2K7KQwTxm0IkItNSHRURzr9Go/view" },
  { nome: "BIONAZ Maria Sole", cv: "https://drive.google.com/file/d/1SOFVYTwRwVitif5QBj8qBYD4ahd2IgAP/view", certificato: "https://drive.google.com/file/d/19oy2Hdlav7JAREBsaHiivswaxRbhOdNX/view" },
  { nome: "BRUNATTO Cristiana", cv: "https://drive.google.com/file/d/1FzvesUNyZR3ap64An1d01HJetgJtFtc8/view", certificato: "https://drive.google.com/file/d/1KPOyxbot9_h-aoYVu26107-sCtbbzfFC/view" },
  { nome: "CAGNINEY Jenny", cv: "https://drive.google.com/file/d/1T7C9KrukDWnWnyAMJgTz8tJxPQd8T1BA/view", certificato: "https://drive.google.com/file/d/1oSg7miS36745QTzs1yhAeJcUnN-mSFGY/view" },
  { nome: "CANONICA Chiara", cv: "https://drive.google.com/file/d/17-MDtftMcHtQ2iCDNruBJ9mc1meCfoJK/view", certificato: "https://drive.google.com/file/d/1P2gPn8BPzTDqNErAWKrHzHzeurIonZZA/view" },
  { nome: "CINTORI Lorenzo", cv: "https://drive.google.com/file/d/1tGzomCKkAwi8kPer177RDdJjSYaxuHp4/view", certificato: "https://drive.google.com/file/d/1tnWRbTvkqgGtoPxObltEowVbbhqjq463/view" },
  { nome: "COMINOLO Cristina", cv: "https://drive.google.com/file/d/1wIhioEnAgDCUQISTc9WBa-KtF7HmZ18x/view", certificato: "https://drive.google.com/file/d/1p0oyzhTB4V_jIupqs4dsOrXEiGtsEtc5/view" },
  { nome: "CONFORTO Francesco", cv: "https://drive.google.com/file/d/1SJIDkT_Kn6-m2E4ZJuye-yF_jBoOEy9x/view", certificato: "https://drive.google.com/file/d/1yhf2kiVBrVFAwySzYFDHcEPd9SJ06Ozk/view" },
  { nome: "CORDEDDU Edy", cv: "https://drive.google.com/file/d/1tm1ZhQVX2ITi1WSSlV4GkGpjd3lu1qNn/view", certificato: "https://drive.google.com/file/d/1LQtoXjPFlr6gyoF-LPq1ZYTysMPUnVEu/view" },
  { nome: "CUAZ Giorgio Ugo Carlo", cv: "https://drive.google.com/file/d/1_gaCzgYdyIz0VrKrba9Y5fdlEXIAxZZl/view", certificato: "https://drive.google.com/file/d/16JCAuRZ_YqYWVzvS23L1nlgrgvloN70W/view" },
  { nome: "FRESIA PAPARAZZO Mirko", cv: "https://drive.google.com/file/d/1wgMzutBaG5jNzAxnzu-SASehOtUz99YY/view", certificato: "https://drive.google.com/file/d/1Etioq_tqP2u3aqBKl3EqNDlHp5ur39Fj/view" },
  { nome: "FURINI Jonathan", cv: "https://drive.google.com/file/d/1yQPcfUfit86HPia-z-Z0Bm2jKJTasoyp/view", certificato: "https://drive.google.com/file/d/1SZqNUhyvBlXBE3OO-4yYUY7NXgfcSoZg/view" },
  { nome: "GOLIA Moreno", cv: "https://drive.google.com/file/d/1P3MqqdVs99zQ3DvsGZ2H69_olnHrMw4Z/view", certificato: "https://drive.google.com/file/d/1BuTIhqL6NVI_jG83S_l_0C1jErpe1DU4/view" },
  { nome: "IERACE Cristina", cv: "https://drive.google.com/file/d/1LAc13HExVlpDGx-yKuGqeXeLfczq5f66/view", certificato: "https://drive.google.com/file/d/1MpMajXfhS23gl3cCVUDWpKF0jN8hdF-1/view" },
  { nome: "LLESHI Aleks", cv: "https://drive.google.com/file/d/1VMaSgAfWMaDugKRr7vZ56xAJPjiQBX9W/view", certificato: "https://drive.google.com/file/d/1ksqUpn8vVaGUx0OorvVsIPQqjFHqyh9y/view" },
  { nome: "MAURO Fabio", cv: "https://drive.google.com/file/d/1nuzj8j26cUrJYrrWpY9tHBpvc7Rrsl0B/view", certificato: "https://drive.google.com/file/d/1GZAzRaU263BdayLn9pIR67rQ8uwd8Enw/view" },
  { nome: "MESTIERI Roberto", cv: "https://drive.google.com/file/d/1jQE5atmdjrMaNSECVOmAtWNXFW0JYm9B/view", certificato: "https://drive.google.com/file/d/1ARwkaHXAF7eBdtJkDAGEaCZXib-wIv9f/view" },
  { nome: "OLIVERIO Antonio", cv: "https://drive.google.com/file/d/11uF25gJB5tIk_BXxDdeil1i_drQvPYIr/view", certificato: "https://drive.google.com/file/d/1FflFxmHyNxoUiJDanKgmCX9Gs0orjryr/view" },
  { nome: "PAPALIA Davide", cv: "https://drive.google.com/file/d/1u0m2wC03TOM1PTsfQvbidChD4SYg66Dx/view", certificato: "https://drive.google.com/file/d/1TEBzR-OLh_ifLGEI_RywoTl6YO838THh/view" },
  { nome: "POLICANTE Luigi", cv: "https://drive.google.com/file/d/11WK9sq-djKSBrDzfxJIES3at9BQLLmWC/view", certificato: "https://drive.google.com/file/d/1JKoJ8lrNe4p-XahcGS1Yr1Puq7nS-_Q4/view" },
  { nome: "RASO Giuseppe", cv: "https://drive.google.com/file/d/1FjHj0VZd_8GKM48BH5b4O8TPwfZ8UL6C/view", certificato: "https://drive.google.com/file/d/1axokhC5UC3ONffuDtRFBNAht-iIS1g2R/view" },
  { nome: "SCAPOLI Rossana", cv: "https://drive.google.com/file/d/1rABCRR9II8hChlvhyvSOqNyWoM8fEPTQ/view", certificato: "https://drive.google.com/file/d/1GGLpcrp3gz3nQspJ-XVmgS5gwGlqeA9w/view" },
  { nome: "TILLIER Alessandro", cv: "https://drive.google.com/file/d/1RrA_h405JupZ1SRgirT_XPBv8v1zxsH3/view", certificato: "https://drive.google.com/file/d/15N0VEIayRPKYr5aIGY9SQhkA2QZTHkLk/view" },
  { nome: "VENTRINI Rosalia", cv: "https://drive.google.com/file/d/1JtDOr5Mk8AdPNXbQCtsgiEb0oddNbO82/view", certificato: "https://drive.google.com/file/d/1Gv4X9ZOVN5gY8TFNOHO-reE1zmuRgQz1/view" },
  { nome: "VIGLINO Arianna", cv: "https://drive.google.com/file/d/1j7GeVnwYtRC8ZSbdFc1HJrp__0SHwZGd/view", certificato: "https://drive.google.com/file/d/1TraJmxf2_j4wHQhfmEvk0MPgWqES773S/view" }
];

export const candidatiRegionali = [
  { nome: "ACCURSO Angelica", cv: "https://drive.google.com/file/d/1mRHdraq98Jc88uQO8pfZWRXVMPPQrRYN/view", certificato: "https://drive.google.com/file/d/1n60lPfUqS1XK09D1z1Fv8obmhjaWvrIL/view" },
  { nome: "AMOROSO Giovanni", cv: "https://drive.google.com/file/d/1g_ttwdYV3GRpemDj2rMDT9-Y7T6GOUwJ/view", certificato: "https://drive.google.com/file/d/1gUARA9lbq0Wm8kbeIcSbtHBOgdeEVxl6/view" },
  { nome: "BACCEGA Mauro", cv: "https://drive.google.com/file/d/13YftHrOk6mlFBZ3mSpA7znWSV6jvkkGt/view", certificato: "https://drive.google.com/file/d/1VsBO9B1r7N7JwXbILQ1HCK4SPwYUtg9R/view" },
  { nome: "BACCINI Eleonora", cv: "https://drive.google.com/file/d/10LHSW0qfxmgX7TMdwL6u48GEGN4y6wsD/view", certificato: "https://drive.google.com/file/d/1aQKgQuDFdTyR7rsccICJWHdRVQLZsASn/view" },
  { nome: "BALBIS Roberta Carla", cv: "https://drive.google.com/file/d/13Z4GCxRUfiJZt7JUaWLb1QC1eCIao84N/view", certificato: "https://drive.google.com/file/d/1XKfAsw31N_nBvqnIOS5Z9AwMHyd5s_RA/view" },
  { nome: "BARMASSE Celine", cv: "https://drive.google.com/file/d/1MZYR2hWo65h-uyUkleAm25QQZf_mDPsU/view", certificato: "https://drive.google.com/file/d/1zOFAM8q3yzBB6nktKq2qYJvvxDjNvRzu/view" },
  { nome: "BIELER Vanda", cv: "https://drive.google.com/file/d/1ey0HqgLBCv68Zx_L9aMb81U-s9nCma1Y/view", certificato: "https://drive.google.com/file/d/1GeUwqWTuAhR75Wqp-qaCj0tStHjfxaki/view" },
  { nome: "BIONAZ Laura", cv: "https://drive.google.com/file/d/1Vkl3dobpE4si3mYsF2knLS-ST5ZGz33S/view", certificato: "https://drive.google.com/file/d/1gIV17G4uzniJ22pKEttm7C3O7lPlhgQP/view" },
  { nome: "CAZZATO Salvatore", cv: "https://drive.google.com/file/d/1zspKr0ZhUbPMBYiyk-CNmdqqFHq2JeIc/view", certificato: "https://drive.google.com/file/d/171jWMFOJbkl-I9nUC1zgdIcDzfHh1YgD/view" },
  { nome: "CHATRIAN Massimo", cv: "https://drive.google.com/file/d/1SJbzN5ycOFdaD4RO2JuraOT2c2stwWkC/view", certificato: "https://drive.google.com/file/d/1lomXGdn8yVCkhx126RJGdbBa0FSmWk0I/view" },
  { nome: "CREMONESE Orianna", cv: "https://drive.google.com/file/d/1k3tl4tWZ5ij0GajayDAyP58DXlC2pENl/view", certificato: "https://drive.google.com/file/d/1TxlZvqx39w1N7kImbY_KoPGa1qHnzOva/view" },
  { nome: "CURIGHETTI Marco", cv: "https://drive.google.com/file/d/1e-yb3BD4TPKXm5CgwASGHZQSGE0BFQzJ/view", certificato: "https://drive.google.com/file/d/1FwWBeLg14NjVaD_faH7rzUo7lCMed9Jk/view" },
  { nome: "DEROSSO Walter", cv: "https://drive.google.com/file/d/1yYtvy6aZd6Zxact21T8UX5utlXCCm_x-/view", certificato: "https://drive.google.com/file/d/1Dci4Iv5Tj0o26Kk1c7dTAv6LbwfiN1Dw/view" },
  { nome: "DIEMOZ Milena", cv: "https://drive.google.com/file/d/1x_vUFHtUuMcakIHSqiZ3nUhgQ1RCo8-7/view", certificato: "https://drive.google.com/file/d/17MSXiBD3zGei40HP1NBmrzfJGVchmw3r/view" },
  { nome: "FLORIO Francesca", cv: "https://drive.google.com/file/d/1KdHrOBgtwvcMv0CA2FCFBh3YiF5wLorp/view", certificato: "https://drive.google.com/file/d/1QGyTJjHTQVz8i0SgWhvRxJHvW53AzBtW/view" },
  { nome: "GANIS Christian", cv: "https://drive.google.com/file/d/1QrV8vrxeTgoOrdg1KKdCpTtHJvyrUfub/view", certificato: "https://drive.google.com/file/d/15KhHJtshZsrpMf0wv8BLXeOvJTyPiFii/view" },
  { nome: "GERANDIN Elso", cv: "https://drive.google.com/file/d/1r5NkmolRJLbmqByBbMj0Ruo-aDcCuG-2/view", certificato: "https://drive.google.com/file/d/1agl2Wg2DVkUOW2lQMgLt7b_k_So3eWzy/view" },
  { nome: "GIRASOLE Luca", cv: "https://drive.google.com/file/d/1z0IoQQ_ZSmLcM_7CE-zASwCEHeVJUhIa/view", certificato: "https://drive.google.com/file/d/1j5HMLI8QVhPmF6r3KfIctx0l28CLNJ9S/view" },
  { nome: "GUIDI Katia", cv: "https://drive.google.com/file/d/1JDLtzG8Y-bW_OzA5xq4Zsh-mCUpSnVLo/view", certificato: "https://drive.google.com/file/d/1-easSpAHRhtlUfRP4GZpzq1P0UwJ2gLR/view" },
  { nome: "MARGUERET Corinne", cv: "https://drive.google.com/file/d/1u29YYKVXUMH0FZhxziM6JEGCtL6DuzGd/view", certificato: "https://drive.google.com/file/d/1VIhIV1V9wWsv3U4Xne29UM3BxLMYy0kq/view" },
  { nome: "MARQUIS Pierluigi", cv: "https://drive.google.com/file/d/1lObvgyeN-BccGwexjBoJlRua5i4jSmEg/view", certificato: "https://drive.google.com/file/d/1AjihsxxRKF2dBXUPiqxspvCezZOsR7xl/view" },
  { nome: "MICHIELETTO Martine", cv: "https://drive.google.com/file/d/1pH33XK_P6pO6hVSkpJUHXaPzJoF1zHGj/view", certificato: "https://drive.google.com/file/d/1EswlVXsGOmPkgweNC3q6tfQ_VeoUKVsc/view" },
  { nome: "MILLERET Philippe E.", cv: "https://drive.google.com/file/d/16ozh3FGAP_wpD9vqByHUXkWBBV_yLGnx/view", certificato: "https://drive.google.com/file/d/1hkeeB1EIfWtURWYP6y_Obj1IFaNOFkSR/view" },
  { nome: "MOUTAZAKKI Mostafa", cv: "https://drive.google.com/file/d/1ATXs2d_maZSMGsU6jhMOieuS5cntVoWd/view", certificato: "https://drive.google.com/file/d/1Wl5c0R8pXhPgcQfi3XqGw0uh4ls4R4l6/view" },
  { nome: "PATACCHINI Gabriella", cv: "https://drive.google.com/file/d/18DN-pvKaHrXDAcACtR6SA_3DUv2Ch7jq/view", certificato: "https://drive.google.com/file/d/1PdzV-tnUp9WLgxP7MzmYoFWsgIVuB1Ay/view" },
  { nome: "PATRIZIO Massimo", cv: "https://drive.google.com/file/d/1LXN6fbIhlgbyf4_wvx1XDoQc6egywlFs/view", certificato: "https://drive.google.com/file/d/1jkq9Acgvo4ZFKz78T2mlA8x6-vBMW8UJ/view" },
  { nome: "PIETRAFESA Rocco", cv: "https://drive.google.com/file/d/1rM-bTQu6llK4WXodHKmgYcJOY56OJlQ1/view", certificato: "https://drive.google.com/file/d/1kZWDf0eTcy9oSidwgCGEdbukTzN-6rno/view" },
  { nome: "POLIANI Gabriella", cv: "https://drive.google.com/file/d/1Z0ScaEnxiUdn_5gOLvY8mFbdF-A6GyK2/view", certificato: "https://drive.google.com/file/d/1yp1Y8J39OpUe902AUloDyokA2xHb_7LU/view" },
  { nome: "RENNA Fausto", cv: "https://drive.google.com/file/d/12698dfKtt9albJ1JA4bkOUk81K1bhTYY/view", certificato: "https://drive.google.com/file/d/1CD46rsQVTjHiM1m20uhtsVOIU0OVrCFm/view" },
  { nome: "RUSSO Sergio", cv: "https://drive.google.com/file/d/1k8slPwN1M58oJVzaBql_0bi5Wq19CYNB/view", certificato: "https://drive.google.com/file/d/1UETX2BjFblerSA5kIPdq4N-hQsj_ftR4/view" },
  { nome: "SORBARA Marco", cv: "https://drive.google.com/file/d/1-OSCTyuXDPLmJguWAcZvrfMMP4UnQrZe/view", certificato: "https://drive.google.com/file/d/1tmMaZSW6CbkAhKx2k2l3FviHyPeX7ByQ/view" },
  { nome: "SPALLA Uberto", cv: "https://drive.google.com/file/d/124yNJm-YW5MNK0B_8JE67nfwfNNKqmVv/view", certificato: "https://drive.google.com/file/d/1nUTCWj78uKD2jifD_nwWcDs0aDLYgS0G/view" },
  { nome: "STACCHETTI Dante", cv: "https://drive.google.com/file/d/1_fcqMyFF7UCcgXhgGaPQaesqI9fABOl9/view", certificato: "https://drive.google.com/file/d/1p1eG9x0R6FZFVrHHV7n67piYEIsAOXxm/view" },
  { nome: "TRUCHET Henry", cv: "https://drive.google.com/file/d/10Nnx7bkG4wHDp-RjHADNQDyqAgtKEU9I/view", certificato: "https://drive.google.com/file/d/1soCK4lCGiWHojlIZEjNkzwh34p2Qsq4r/view" },
  { nome: "VITTAZ Elena", cv: "https://drive.google.com/file/d/1JvVqZAmc9EXHMs7UXSfVVIEqc1ALPTMx/view", certificato: "https://drive.google.com/file/d/1PZxxC3Eip1UOzjfxqOIFHIbxwYS9TiYw/view" }
];

export const storiaTimeline = [
  {
    data: "28 febbraio 2020",
    titolo: "La nascita",
    descrizione: "Rinascimento Valle d'Aosta si presenta ai principali mezzi di comunicazione e inizia la storia di una splendida avventura."
  },
  {
    data: "20-21 settembre 2020",
    titolo: "Prime elezioni",
    descrizione: "Rinascimento Valle d'Aosta presenta due squadre alle elezioni Amministrative per il Comune di Aosta e alle elezioni Regionali per il rinnovo del Consiglio."
  },
  {
    data: "4-5 ottobre 2020",
    titolo: "Successo al ballottaggio",
    descrizione: "Per la prima volta in Valle d'Aosta si è votato al secondo turno per le elezioni comunali. Rinascimento Valle d'Aosta, da solo e senza nessuna coalizione, ottiene il 46,66% ed entra in minoranza in Consiglio comunale ad Aosta con quattro consiglieri."
  },
  {
    data: "29 maggio 2022",
    titolo: "Nuovo nome e simbolo",
    descrizione: "Primo Congresso del movimento civico, Rinascimento Valle d'Aosta cambia nome e simbolo e diventa La Renaissance Valdôtaine."
  },
  {
    data: "28 maggio 2024",
    titolo: "Conferma della leadership",
    descrizione: "La Renaissance Valdôtaine conferma Giovanni Girardini come presidente e il nuovo Direttivo comprende: Roberta Carla Balbis (segretaria), Orianna Cremonese (segretaria amministrativa), Elso Gerardin e Rossana Scapoli (consiglieri)."
  }
];

export const valori = [
  {
    id: 1,
    titolo: "Il cittadino al centro",
    contenuto: `Stiamo assistendo a una crescente disaffezione della popolazione nei confronti della politica e molti cittadini manifestano la loro demotivazione attraverso un elevato tasso di astensionismo elettorale, fenomeno indicativo di una crisi della democrazia.

Dove l'ignoranza sul valore del sistema democratico lascia spazio alla prevalenza del più forte, la paura del cambiamento e la pigrizia nel lasciare la propria zona di comfort ostacolano qualsiasi processo di rinnovamento, La Renaissance Valdôtaine propone di coinvolgere attivamente ogni cittadino affinché la politica torni a essere patrimonio di tutti.

La gestione amministrativa attuale è priva di progettualità e orientata unicamente a preservare uno status quo stagnante, non rispondendo più alle vere esigenze della nostra comunità. È essenziale inaugurare una nuova era in cui la politica interpreti autenticamente le necessità dei cittadini.

Noi crediamo che la politica abbia il compito di sostenere il cittadino e il bene comune. Le persone hanno il diritto di realizzare i propri obiettivi sulla base delle capacità e dell'impegno.`
  },
  {
    id: 2,
    titolo: "La sanità è per tutti",
    contenuto: `Vogliamo sostenere una sanità pubblica di qualità e accessibile a tutti, enfatizzando l'importanza di un sistema sanitario che rispetti le specificità locali e le esigenze della popolazione valdostana.

Siamo a favore di un potenziamento delle strutture sanitarie locali, della formazione del personale medico e paramedico, e dell'implementazione di servizi che possano rispondere adeguatamente alle necessità della comunità, come ad esempio la telemedicina e i servizi di assistenza domiciliare.

È necessaria una rivalutazione dell'ospedale regionale, attraverso una gestione più consapevole e diretta, premi la meritocrazia e diventi un'attrattiva forte per i medici specialisti in modo da disincentivare la fuga all'esterno, in Svizzera in particolare, degli operatori sanitari a tutti i livelli.

È fondamentale garantire un luogo di lavoro sereno, efficiente e adeguato a tutto il personale sanitario, attraverso una migliore gestione dei turni di lavoro e gratificando economicamente i lavoratori.`
  },
  {
    id: 3,
    titolo: "La formazione alla base del lavoro",
    contenuto: `La formazione alla base del lavoro rappresenta le fondamenta di una società migliore, la preparazione e l'educazione devono essere fondamentali non solo per il progresso individuale, ma anche per il benessere collettivo della società.

Promuoviamo un approccio di formazione multidisciplinare che possa contribuire a formare individui non solo competenti nel loro specifico campo di lavoro, ma anche capaci di pensare criticamente e di innovare. L'idea che un lavoratore debba possedere una solida base culturale è un pilastro della formazione professionale.

Per noi è fondamentale la responsabilità sociale, sosteniamo infatti che il lavoro non è solo un mezzo di sussistenza, ma anche un modo per contribuire al progresso della società. La formazione diventa quindi un veicolo per sviluppare non solo competenze professionali, ma anche valori etici e civici, preparando gli individui a essere cittadini consapevoli e attivi.`
  }
];

export const programmaRegionale = [
  {
    id: 0,
    titolo: "Linee guida trasversali",
    punti: [
      "Rafforzare la capacità politico-amministrativa di spesa",
      "Semplificazione e sburocratizzazione per cittadini e imprese",
      "Utilizzo pieno delle risorse: stop ai 300 milioni di euro non spesi ogni anno",
      "Riduzione della pressione fiscale (IRPEF, IRAP, IMU, tassa automobilistica)",
      "Taglio del costo dell'energia elettrica per famiglie e imprese",
      "Agevolazioni sul pedaggio autostradale per residenti e imprese"
    ]
  },
  {
    id: 1,
    titolo: "Riforma elettorale",
    punti: [
      "Stabilità di Governo per Risposte Concrete",
      "Elezione Diretta del Presidente della Giunta",
      "Aumento del Numero di Preferenze",
      "Garanzia di Rappresentanza Territoriale e Walser"
    ]
  },
  {
    id: 2,
    titolo: "Sanità",
    punti: [
      "Abbattimento delle liste d'attesa",
      "Voucher per prestazioni nel privato quando il pubblico non garantisce i tempi",
      "Investimenti nella medicina territoriale",
      "Potenziamento delle RSA e osservatorio anziani"
    ]
  },
  {
    id: 3,
    titolo: "Ospedale nuovo",
    punti: [
      "Procedere con rapidità alla fase 3",
      "Focus sul contenuto oltre che sul contenitore",
      "Attrarre più medici con politiche mirate",
      "Collaborazione con grandi centri ospedalieri"
    ]
  },
  {
    id: 4,
    titolo: "Trasporti",
    punti: [
      "Seconda canna del Traforo del Monte Bianco",
      "Raddoppio selettivo dei binari ferroviari Aosta-Ivrea",
      "Potenziamento volo leggero turistico",
      "Riduzione pedaggi autostradali per residenti"
    ]
  },
  {
    id: 5,
    titolo: "Agricoltura e ambiente",
    punti: [
      "Sostegno all'agricoltura locale e biologica",
      "Revisione disciplinare fontina",
      "Protezione ambientale e biodiversità",
      "Istituzione della GUARDIA DEL TERRITORIO"
    ]
  },
  {
    id: 6,
    titolo: "Collegamenti intervallivi",
    punti: [
      "Collegamento Pila-Cogne",
      "Infrastrutture di mobilità montana",
      "Collegamento Cime Bianche"
    ]
  },
  {
    id: 7,
    titolo: "Giovani",
    punti: [
      "Sostegno all'occupazione giovanile",
      "Incentivi per start-up",
      "Formazione e cultura digitale"
    ]
  },
  {
    id: 8,
    titolo: "Istruzione",
    punti: [
      "Rafforzamento bilinguismo italiano-francese",
      "Potenziamento inglese",
      "Innovazione nelle scuole",
      "Corsi abilitanti per insegnanti in Valle d'Aosta"
    ]
  },
  {
    id: 9,
    titolo: "Disabilità",
    punti: [
      "Assessorato regionale dedicato",
      "Politiche di inclusione nel lavoro e scuole",
      "Sport per disabili e strutture accessibili"
    ]
  },
  {
    id: 10,
    titolo: "Cultura e sport",
    punti: [
      "Valorizzazione della cultura locale",
      "Sostegno alle associazioni sportive",
      "Finanziamenti mirati per tradizioni valdostane"
    ]
  },
  {
    id: 11,
    titolo: "Lavoro e occupazione",
    punti: [
      "Agenzia regionale per istanze aziendali",
      "Semplificazione accesso ai bandi",
      "Nuovi bandi per imprenditoria giovanile e femminile",
      "Obbligo di scorporo opere negli affidamenti pubblici"
    ]
  },
  {
    id: 12,
    titolo: "Famiglie",
    punti: [
      "Bonus regionale nascita (+500€ per figlio)",
      "Agevolazioni fiscali per famiglie montane",
      "Housing sociale montano",
      "Voucher per centri estivi e servizi di cura"
    ]
  },
  {
    id: 13,
    titolo: "Commercio",
    punti: [
      "Riforma legge sul commercio",
      "Riduzione IRAP e IMU per attività montane",
      "Fondo 'Negozi vivi' per riaperture",
      "Sportello unico digitale regionale"
    ]
  },
  {
    id: 14,
    titolo: "Turismo",
    punti: [
      "Bandi ristrutturazioni per alloggi stagionali",
      "Accordi bilaterali per manodopera",
      "Cabina di regia unica per marketing",
      "Semplificazione burocratica"
    ]
  },
  {
    id: 15,
    titolo: "Autonomia",
    punti: [
      "Rapporto sano con lo Stato",
      "Europa dei popoli",
      "Consolidare e ampliare strumenti di autogoverno"
    ]
  }
];

export const notizieInEvidenza = [
  { nome: "Aosta Sera", url: "https://aostasera.it/notizie/politica/giovanni-girardini-confermato-alla-guida-de-la-renaissance-valdotaine/" },
  { nome: "Aosta Oggi", url: "https://www.aostaoggi.it/politica/28981-elezioni-2025-renaissance-costruire-un-centro-moderato-e-autonomista" },
  { nome: "Gazzetta Matin", url: "https://www.gazzettamatin.com/2024/08/01/la-renaissance-al-lavoro/" },
  { nome: "Valle d'Aosta G Local", url: "https://www.valledaostaglocal.it/2024/08/01/leggi-notizia/argomenti/consiglio-valle/articolo/la-renaissance-valdotaine-riafferma-i-propri-valori.html" },
  { nome: "La Prima Linea", url: "https://www.laprimalinea.it/2024/05/28/leggi-notizia/argomenti/politica-29/articolo/giovanni-girardini-confermato-presidente-di-la-renaissance-valdotaine.html" }
];

export const versamenti = [
  {
    mese: "Novembre 2025",
    contributi: [
      { nome: "Giovanni Girardini", importo: 400 },
      { nome: "Cristina Dattola", importo: 400 },
      { nome: "Arianna Viglino", importo: 400 },
      { nome: "Eleonora Baccini", importo: 2800 },
      { nome: "Arianna Viglino", importo: 1000 },
      { nome: "Cristina Dattola", importo: 1000 },
      { nome: "Eleonora Baccini", importo: 2200 }
    ]
  },
  {
    mese: "Dicembre 2025",
    contributi: [
      { nome: "Giovanni Girardini", importo: 300 },
      { nome: "Giovanni Girardini", importo: 751 }
    ]
  },
  {
    mese: "Febbraio 2026",
    contributi: [
      { nome: "Eleonora Baccini", importo: 1200 },
      { nome: "Giovanni Girardini", importo: 765.45 },
      { nome: "Arianna Viglino", importo: 735 }
    ]
  },
  {
    mese: "Marzo 2026",
    contributi: [
      { nome: "Cristina Dattola", importo: 600 },
      { nome: "Eleonora Baccini", importo: 1200 },
      { nome: "Giovanni Girardini", importo: 500 },
      { nome: "Giovanni Girardini", importo: 1400 },
      { nome: "Orlando Navarra", importo: 500 }
    ]
  }
];

export const trasparenzaLegge = `LEGGE 9 gennaio 2019, n. 3 – Misure per il contrasto dei reati contro la pubblica amministrazione, nonché in materia di prescrizione del reato e in materia di trasparenza dei partiti e movimenti politici. (18G00170) (GU Serie Generale n.13 del 16-01-2019)

"Entro il quattordicesimo giorno antecedente la data delle competizioni elettorali di qualunque genere, escluse quelle relative a comuni con meno di 15.000 abitanti, i partiti e i movimenti politici, nonché le liste di cui al comma 11, primo periodo, hanno l'obbligo di pubblicare nel proprio sito internet il curriculum vitae fornito dai loro candidati e il relativo certificato penale rilasciato dal casellario giudiziale non oltre novanta giorni prima della data fissata per la consultazione elettorale.

Ai fini dell'ottemperanza agli obblighi di pubblicazione nel sito internet di cui al presente comma non è richiesto il consenso espresso degli interessati."`;
